/* Escape html entities avoid xss <script> */
export default function escapeHtml(str) {
  // .replace(/&/g, '&amp;')
  return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
